module.exports = __webpack_public_path__ + "assets/img/Type E (55).403baaf6.jpg";